export default class {
    constructor() {
        window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

        this.$header = $("#header-wrapper");
        this.$page = $("#page-wrapper");
        this.$carousel = $(".frame-type-carousel_fullscreen");
        this.$arrowDropdown = $(".scroll-to-bottom");

        this.headerOffset = 0;
        this.sticky = false;
        this.animationTicking = false;
        this.latestKnownScrollY = 0;

        this.onScroll = this.onScroll.bind(this);
        this.requestAnimationTick = this.requestAnimationTick.bind(this);
        this.update = this.update.bind(this);
        this.stick = this.stick.bind(this);
        this.unstick = this.unstick.bind(this);
        this.scrollToAnchor = this.scrollToAnchor.bind(this);

        const $pageHeader = this.$header.find("#page-header");
        $pageHeader.find(".navbar-toggler").click(function () {
            $pageHeader.toggleClass("solid", !$("#mainmenu").hasClass("show"))
            $('body').toggleClass("mobile-menu-open", !$("#mainmenu").hasClass("show"))
        });

        if (this.$carousel.length) {
            this.$carousel.css('margin-top', '-100px');
            document.addEventListener('scroll', this.onScroll, false);
        } else {
            this.stick()
        }

        $('a[href^="#"]').on('click', ev => {
            const target = $(ev.currentTarget.hash);
            if (target.length) {
                ev.preventDefault();
                this.scrollToAnchor(target);
            }
        });
    }

    scrollToAnchor(anchor) {
        let topOffset = anchor.offset().top;
        $('html, body').animate({
            scrollTop: topOffset - $("#page-header").height()
        }, 500);
        this.latestKnownScrollY = topOffset;
    }

    onScroll() {
        if (!this.sticky)
            this.headerOffset = this.$header.offset().top;

        this.latestKnownScrollY = $(window).scrollTop();

        this.requestAnimationTick();
    }

    requestAnimationTick() {
        if (!this.animationTicking)
            window.requestAnimationFrame(this.update);

        this.animationTicking = true;
    }

    update() {
        // reset for next onScroll capture
        this.animationTicking = false;

        if (!this.sticky && this.latestKnownScrollY > this.headerOffset)
            this.stick();

        else if (this.sticky && this.latestKnownScrollY <= this.headerOffset)
            this.unstick();
    }

    stick() {
        this.sticky = true;
        this.$page.css('padding-top', `${this.$header.height()}px`);
        this.$header.addClass('sticky');
    }

    unstick() {
        this.sticky = false;
        this.$page.css('padding-top', '');
        this.$header.removeClass('sticky');
    }
}
